import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import RoutedSavableApp from 'platform/forms/save-in-progress/RoutedSavableApp';
import { isProfileLoading, isLoggedIn } from 'platform/user/selectors';
import { useFeatureToggle } from 'platform/utilities/feature-toggles';
import { useSelector } from 'react-redux';
import formConfig from '../config/form';
import manifest from '../manifest.json';
import Breadcrumbs from '../components/Breadcrumbs';
import NeedHelp from '../components/NeedHelp';
import normalizeReturnUrl from '../config/normalizeReturnUrl';

export default function App({ location, children }) {
  const userLoggedIn = useSelector(state => isLoggedIn(state));
  const profileLoading = useSelector(state => isProfileLoading(state));

  const resumeFormConfig = useMemo(
    () => ({
      ...formConfig,
      normalizeReturnUrl: returnUrl => normalizeReturnUrl(returnUrl),
    }),
    [],
  );

  const { useToggleLoadingValue, useFormFeatureToggleSync } =
    useFeatureToggle();
  const flagsLoading = useToggleLoadingValue();

  useFormFeatureToggleSync([
    {
      toggleName: 'form0803BenefitsIntakeSubmission', // feature toggle name
      formKey: 'view:form0803BenefitsIntakeSubmission', // form data name
    },
  ]);

  useEffect(() => {
    document.title = `Request Licensing or Certification Test Fees Reimbursement Online | Veterans Affairs`;
  }, []);

  useEffect(() => {
    if (
      !userLoggedIn &&
      !profileLoading &&
      location.pathname !== '/introduction'
    ) {
      window.location.href = manifest.rootUrl;
    }
  }, [userLoggedIn, profileLoading, location]);

  if (flagsLoading) {
    return (
      <va-loading-indicator label="Loading" message="Loading your form..." />
    );
  }

  return (
    <div className="form-22-0803-container">
      <div className="vads-u-padding-left--0">
        <Breadcrumbs />
      </div>
      <RoutedSavableApp
        formConfig={resumeFormConfig}
        currentLocation={location}
      >
        {children}
      </RoutedSavableApp>
      <div className="row">
        <NeedHelp />
      </div>
    </div>
  );
}

App.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object,
};
